import * as yup from 'yup';

export const createUpdatePermissionDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  displayName: yup.string().required().label('Display Name'),
  description: yup.string().required().label('Description')
});
